<template>
  <div>
    <van-nav-bar
      title="考试列表"
      left-text="返回"
      left-arrow
      right-text="新增"
      @click-left="onClickLeft"
      @click-right="onClickRight"
    />
    <div class="p-l-1 p-r-1" v-for="(item,i) in userExamList" :key="i" @click="goExamDetial(item)">
      <div class="bg-white m-t-10 b-r-013 f-s-8 p-l-05 p-b-5 p-t-05">
        <p>{{item.addDate}}</p>
        <p>{{item.examName}}</p>
        <div v-show="item.show">
          <van-cell-group>
            <van-cell title="用户名" :value="item.info.uname" />
            <van-cell title="密码" :value="item.info.password" />
            <van-cell title="官网" :value="item.info.address" />
            <van-cell title="成绩" :value="item.info.fraction" />
            <van-cell title="是否合格" :value="item.info.quaName" />
          </van-cell-group>
        </div>
        <van-row class="text-c m-t-10">
          <van-col span="12" :style="payStyle(item.paystater)">{{payText(item.paystater)}}</van-col>
          <van-col span="12" @click.native.stop="lookInfo(item)">{{item.show ? '收起':'查看'}}准考证</van-col>
        </van-row>
      </div>
    </div>
  </div>
</template>

<script>

export default {

  data() {
    return {
      userExamList:[]
    };
  },
  created(){
    this.getUserExamList()
  },
  methods: {
    payStyle(n){
      if(n == 1) {
        return 'color:red'
      } else if(n == 2){
        return 'color:green'
      } else {
        return 'color:black'
      }
    },
    payText(n){
      if(n == 1) {
        return '未支付'
      } else if(n == 2){
        return '已支付'
      } else {
        return '已退款'
      }
    },
    // 去考试详情
    goExamDetial(item){
      this.$router.push({
        path: "/addExam",
        query:{
          id : item.id
        }
      });
    },
    lookInfo(item){
      
      // if(item.paystater != 2) {
      //   this.$dialog.confirm({
      //     title: '提示',
      //     message: '订单暂未支付,不可查看',
      //     confirmButtonText:'去支付',
      //   })
      //     .then(() => {
      //       this.$router.push({
      //         path: "/addExam",
      //         query:{
      //           id : item.id
      //         }
      //       });
      //     })
      //     .catch(() => {
      //       console.log('取消')
      //     });
      //     return false
      // }
      if(item.show == true) {
        item.show = false
        return false
      }
      if(item.info != '') {
        item.show = true
        return false
      }
      item.show = true
      let data = {
        id:item.id
      }
      this.ApiNew.Exam.getExamDataList(data).then(res => {
        console.log(res)
      })
      this.ApiNew.Exam.getUserExamInfoById(data).then(res => {
        if(res.retuCode == 5000) {
          if(res.data.qualified == '1') {
            res.data.quaName = '是'
          } else if(res.data.qualified == '0'){
            res.data.quaName = '否'
          } else {
            res.data.quaName = '暂无信息'
          }
          item.info = res.data
        }
      })
      
    },
    // 获取用户报名列表
    getUserExamList(){
      let data = {
        userId:this.uid()
      }
      this.ApiNew.Exam.getUserExamList(data).then(res => {
        if(res.retuCode == 200) {
          res.data.forEach(item => {
            item.show = false
            item.info = ''
          })
          this.userExamList = res.data
        }
        console.log(res)
      })
    },
    onClickRight() {
      this.$router.push({
        path: "/addExam",
      });
    },
  },
};
</script>

<style scoped>
</style>